import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { AuthProvider, useAuth } from './auth/AuthContext';
import { WebLoginScreen } from './auth/WebLoginScreen';
import { WebCreateProfileScreen } from './auth/WebCreateProfileScreen';
import { WebAppShell } from './shell/WebAppShell';
import { NAV_PATH } from './shell/nav';
import { PublicLegalPage } from './pages/PublicLegalPage';

/** Trong lúc khôi phục phiên từ localStorage — tránh nháy màn đăng nhập rồi nhảy vào app. */
function BootSplash() {
  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--surface-tint)' }}>
      <img src="/assets/torii-mark.svg" alt="Torii" style={{ width: 56, height: 56, opacity: 0.6 }} />
    </div>
  );
}

function AppRoutes() {
  const { status } = useAuth();
  const location = useLocation();

  // Token màu có sẵn bảng dark, nhưng apps/mobile chưa có nút bật nên web cũng chạy
  // light cố định — đổi ở đây khi mobile có cài đặt giao diện.
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);

  // Trang pháp lý công khai — không chờ khôi phục phiên, không bắt đăng nhập (link khai báo với Google OAuth).
  if (location.pathname === '/privacy') return <PublicLegalPage page="privacy" />;
  if (location.pathname === '/terms') return <PublicLegalPage page="terms" />;

  if (status === 'checking') return <BootSplash />;

  const signedIn = status === 'authenticated';

  return (
    <Routes>
      <Route path="/" element={<Navigate to={signedIn ? NAV_PATH.hoc : '/login'} replace />} />
      <Route path="/login" element={<WebLoginScreen />} />
      <Route path="/onboarding" element={signedIn ? <WebCreateProfileScreen /> : <Navigate to="/login" replace />} />
      <Route path="*" element={signedIn ? <WebAppShell /> : <Navigate to="/login" replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
